/* __next_internal_client_entry_do_not_use__ AddedToCartListener auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { useZustandLocation } from "@faire/retailer-visitor-shared/app/_lib/routing/useZustandLocation";
import { LazyAddedToCart } from "@faire/retailer-visitor-shared/components/Notifications/AddedToBag/LazyAddedToCart";
import { useAddedToBag } from "@faire/retailer-visitor-shared/components/Notifications/AddedToBag/useAddedToBag";
import { EventListener } from "@faire/retailer-visitor-shared/components/Notifications/EventListener";
import { AddToCart, AddToCartNotificationFinished } from "@faire/retailer-visitor-shared/events";
import { removeLocaleFromUrl } from "@faire/web--source/ui/routing/util";
import { route as cartRoute } from "@faire/web-api--source/routes/cart";
import React, { Suspense, useMemo } from "react";
import { matchPath } from "react-router-dom";
/**
 * Component listens for add to cart event, and lazy loads AddedToBag
 * component upon the first event publication, then updates child components
 * notification data on each subsequent event publication.
 */ export var AddedToCartListener = function() {
    var shouldIgnore = useAddedToBag().shouldIgnore;
    var _useZustandLocation = useZustandLocation(function(state) {
        return state.pathname;
    }), pathnameWithMaybeLocale = _useZustandLocation.pathname;
    var pathname = useMemo(function() {
        return removeLocaleFromUrl(pathnameWithMaybeLocale);
    }, [
        pathnameWithMaybeLocale
    ]);
    if (matchPath(pathname, cartRoute)) {
        return null;
    }
    return /*#__PURE__*/ _jsx(EventListener, {
        event: AddToCart,
        shouldIgnoreEvent: shouldIgnore,
        eventFinish: AddToCartNotificationFinished,
        eventHandlerElement: eventHandlerElement
    });
};
var eventHandlerElement = function(props) {
    return /*#__PURE__*/ _jsx(Suspense, {
        fallback: null,
        children: /*#__PURE__*/ _jsx(LazyAddedToCart, _object_spread({}, props))
    });
};
